import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { NavBar } from "@app/navigation/ui/nav-bar";
import { myAccountQueryOptions } from "@entities/user/hooks/use-my-account.ts";
import { PageTemplate } from "@shared/ui/templates/page-template";
import { HelpBox } from "@widgets/profile-avatar/ui/help-box";

export const Route = createFileRoute("/_private")({
  beforeLoad: ({ context, location }) => {
    const isAuthenticated = context.getAuthStatus();
    if (!isAuthenticated) {
      throw redirect({
        search: {
          redirect: location.href,
        },
        to: "/sign-in",
      });
    }
  },
  component: RouteComponent,
  loader: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData(myAccountQueryOptions());
    } catch {
      // Ошибку профиля обрабатывает экран (снек + повтор),
      // приватный лэйаут с шапкой и навигацией должен остаться доступен.
    }
  },
});

function RouteComponent() {
  return (
    <PageTemplate
      navigationSlot={<NavBar />}
      profileSlot={<HelpBox email="segunadebayo@mail.com" />}
    >
      <Outlet />
    </PageTemplate>
  );
}
